import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MxButtonModel} from 'mx-core';
import {PortalNotificationPrlObj} from '../../../../models/portal-notification.model';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';
import {
    PrlPortalNotificationService
} from '../../services/portal-notification-page/prl-portal-notification.service';

@Component({
    selector: 'prl-portal-notification-page',
    templateUrl: './prl-portal-notification-page.component.html',
    standalone: false,
    styleUrls: ['./prl-portal-notification-page.component.scss']
})
export class PrlPortalNotificationPageComponent implements OnInit {

    notification: PortalNotificationPrlObj = null;
    acceptButton: MxButtonModel;
    declineButton: MxButtonModel;

    constructor(private languageService: PrlLanguageService,
                private portalNotificationService: PrlPortalNotificationService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.acceptButton = {
            label: () => this.getLabel('label.portal.notification.accept'),
            permission: 'all',
            tooltip: () => this.getLabel('label.portal.notification.accept'),
            className: 'mxs-button--primary',
            clickHandler: () => this.acceptPortalNotification(true)
        };

        this.declineButton = {
            label: () => this.getLabel('label.portal.notification.decline'),
            permission: 'all',
            tooltip: () => this.getLabel('label.portal.notification.decline'),
            className: 'mxs-button--secondary',
            hidden: () => this.notification.mandatory,
            clickHandler: () => this.acceptPortalNotification(false)
        };

        this.showNextNotification();
    }

    getLabel(label: string): string {
        return this.languageService.getLabel(label);
    }

    private acceptPortalNotification(accepted: boolean): void {
        this.portalNotificationService.acceptPortalNotification(this.notification.id, accepted)
            .subscribe(() => this.showNextNotification());
    }

    private showNextNotification(): void {
        this.portalNotificationService.getPortalNotification().subscribe(notification => {
            this.notification = notification;
            if (!notification) {
                this.router.navigate(['/dashboard']);
            }
        });
    }
}
